/**
 * A simple debug logging utility.
 *
 * Debug logging is enabled when the environment variable 
 * `REACT_APP_DEBUG_ENABLED` is set to a truthy value. 
 * When it is disabled, all logging functions become no-ops.
 *
 * Example:
 *
 * Debug.logMessage("Foo");
 * Debug.logGroup("Diagnostics, { speed, rpm, temperature });
 */
const Debug = {

  /**
   * Flags whether debug logging is enabled or not.
   * Derived from the environment variable `REACT_APP_DEBUG_ENABLED`.
   */
  enabled: Boolean(process.env.REACT_APP_DEBUG_ENABLED ?? false),

  /**
   * Logs a debug message with optional additional values.
   * When debug logging is disabled, this function does nothing.
   *
   * @param {string} msg
   *   The main debug message.
   *
   * @param {...any} args
   *   Additional values to log.
   */
  logMessage(msg, ...args) {
    if (!this.enabled) return;
    console.debug("[DEBUG]", msg, ...args);
  },

  /**
   * Logs a collapsed group of values.
   * When debug logging is disabled, this function does nothing.
   *
   * @param {string} header
   *   The group's header message.
   *
   * @param {Record<string, any>} objects
   *   Key-value pairs to log inside the group
   */
  logGroup(header, objects) {
      if (!this.enabled) return;
      console.groupCollapsed("[DEBUG]", header);
      for (const key in objects) {
        console.debug(`${key}:`, objects[key]);
      }
      console.groupEnd();
  }
};

export default Debug;

